/**
 * API client functions for the users directory endpoint.
 * Supports pagination and search. Only accessible to system_admin and org_admin tiers.
 */
import { apiGet } from './client';

export interface UserSummary {
  id: string;
  email: string;
  displayName: string;
  orgId: string | null;
  tier: 'system_admin' | 'org_admin' | 'subscriber' | 'member';
  scopeLevel: string | null;
  createdAt: string;
}

export interface UsersResponse {
  items: UserSummary[];
  nextCursor: string | null;
}

export interface GetUsersParams {
  limit?: number;
  cursor?: string;
  q?: string;
  orgId?: string;
}

export async function getUsers(params: GetUsersParams = {}): Promise<UsersResponse> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set('limit', String(params.limit));
  if (params.cursor) qs.set('cursor', params.cursor);
  if (params.q) qs.set('q', params.q);
  if (params.orgId) qs.set('orgId', params.orgId);
  const query = qs.toString();
  return apiGet<UsersResponse>(`/api/users${query ? `?${query}` : ''}`);
}
